<template>
<van-popup
  :show="show"
  position="right"
  :style="{ width: '80%', height: '100%' }"
  :before-close="handleCloseClick"
  clss="filter-div"
>
  <div class="filter-wrapper">

    <!-- 品类 -->
    <div class="filter-card" v-if="categories.length > 0">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item title="Categories" name="1">
        </van-collapse-item>
        <div class="filter-list">
          <van-checkbox-group v-model="clsCheckIds" shape="square">
            <div 
              v-for="(item, i) in categories"
              :key="i"
              v-show="activeName !== '1' ? i < 3 : true"
              class="filter-item" 
            >
              <van-checkbox 
                checked-color="#DD3131"
                :name="item.id"
                shape="square"
              >{{ item.name }}</van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
      </van-collapse>

      
    </div>
    <van-divider v-if="categories.length > 0" />

    <div class="filter-card" v-if="guarantees.length > 0">
      <p class="card-title">Service & Guarantee</p>
      <div class="filter-list">
        <div 
          v-for="(item, i) in guarantees"
          :key="i"
          class="filter-item" 
        >
          <van-checkbox 
            checked-color="#DD3131"
            v-model="item.checked"
            shape="square"
          >{{ item.name }}</van-checkbox>
        </div>
      </div>
    </div>

    <van-divider v-if="guarantees.length > 0" />

    <div class="filter-card">
      <p class="card-title">Price</p>

      <div class="price-box">
        <van-field v-model="params.priceFrom" placeholder="Lowest price" type="number" />
        <span>-</span>
        <van-field v-model="params.priceTo" placeholder="Highest price" type="number" />
      </div>
    </div>

    <van-divider />

    <div class="filter-card" v-if="deliveries.length > 0">
      <p class="card-title">Shipped From</p>
      <div class="filter-list">
        <div class="filter-item" v-for="item in deliveries">
          <van-checkbox 
            checked-color="#DD3131"
            v-model="item.checked"
            shape="square"
          >{{ item.name }}</van-checkbox>
        </div>
      </div>
    </div>

    <!-- 属性 -->
    <div class="attr-list" :key="'attr_item_' + index" v-for="(item, index) in attrLists">
      <van-divider />
      <div class="filter-card">
        <van-collapse v-model="item.isShow" accordion>
          <van-collapse-item :title="`${item.name}${item.values.length > 3 ? `(${item.values.length})` : ''}`" name="1" />
            
          <div class="filter-list">
            <van-checkbox-group v-model="item.checked" shape="square">
              <div 
                v-for="(childItem, childIdx) in item.values"
                :key="'attr_value' + index + childIdx"
                v-show="!item.isShow ? childIdx < 3 : true"
                class="filter-item" 
              >
                <van-checkbox 
                  checked-color="#DD3131"
                  :name="childItem.value"
                  shape="square"
                >{{ childItem.value }}</van-checkbox>
              </div>
            </van-checkbox-group>
          </div>
        </van-collapse>
      </div>
    </div>
  </div>

  <div class="bottom-opt">
    <van-button block @click="handleResetClick" plain type="primary">Reset</van-button>
    <van-button block @click="handleApplyClick" type="primary">Apply</van-button>
  </div>
</van-popup>
</template>

<script setup lang="ts">
import { watchEffect } from 'vue'
import { type ISearchParams } from '@/api/models/system'

interface IProps { filter: any, defaultParams?: ISearchParams }
const props = defineProps<IProps>()
const emits = defineEmits<{
  (event: 'filter:apply', params: any):void
  (event: 'update:show', show: boolean):void
}>()

// const { $getTypeof } = useNuxtApp()
const show = ref<boolean>(false)
const params = ref<ISearchParams>({ priceFrom: '', priceTo: '' })
const guarantees = ref<any>([])
const deliveries = ref<any>([])
const shipped = ref<any>([])
const categories: any = ref([])
const clsCheckIds: Ref<any[]> = ref([])
const attrLists: any = ref([])
const attrFilters: any = ref([])
const activeName = ref('0')
const isReset = ref(false)
// const route = useRoute()
const { backCid } = useRoute().query 

if(backCid) {
  // clsCheckIds.value = $getTypeof(backCid) === 'Array' ? backCid as any[] : [backCid]
  clsCheckIds.value = backCid ? (backCid as string).split('_') : []
}

const attrValueInit = () => {
  // 属性值初始化选中
  attrLists.value.forEach((item: any) => {
    item.checked = []
    attrFilters.value.forEach((sldItem: any) => {
      if(sldItem.name === item.name && sldItem.values) {
        item.checked = sldItem.values
      }
    })
  })
}
const initFilter = () => {
 
  const defParams = props.defaultParams || {}
  guarantees.value = (props.filter.guarantees || []).map((c: any) => {
    if(isReset.value) {
      c.checked = false
    } else {
      c.checked = defParams[c.paramName as keyof ISearchParams] === c.paramValue
    }
    return c
  })

  deliveries.value = (props.filter.deliveries || []).map((c: any) => {
    if(isReset.value) {
      c.checked = false
    } else {
      c.checked = defParams[c.paramName as keyof ISearchParams] === c.paramValue
    }
    return c
  })

  categories.value = props.filter.categories ? props.filter.categories[0].subCategories : []
  attrLists.value = props.filter.attrs || []
  attrValueInit()

  shipped.value = [
    { key: '', label: 'All', checked: false },
    ...(props.filter.shipped || []).map((c: any) => ({ 
      key: c,
      label: c,
      checked: false
    }))
  ]
  shipped.value.forEach((c: any) => {
    c.checked = (defParams.shipped || '') === c.key
  })
}
watchEffect(initFilter)

const handleShippedItemClick = (item: any) => {
  shipped.value.forEach((c: any) => {
    c.checked = item.key === c.key
  })
}

const handleResetClick = () => {
  isReset.value = true
  attrFilters.value = []
  initFilter()
  params.value.priceFrom = ''
  params.value.priceTo = ''
  clsCheckIds.value = []
  // attrValueInit()
}
const handleApplyClick = () => {
  isReset.value = false
  const addParams = (objs: any): any => {
    const p:any = {}

    objs.forEach((obj: any) => {
      obj.filter((c: any) => c.checked).forEach((v:any) => {
        p[v.paramName] = v.paramValue
      })  
    })
    return p
  }

  const otherParams: any = addParams([guarantees.value, deliveries.value])
  const shippedKey = shipped.value.find((c: any) => c.checked)?.key

  const nextAttrFilters = attrLists.value
    .filter((item: any) => item.checked && item.checked.length)
    .map((item: any) => ({
      name: item.name,
      values: [...item.checked]
    }))
  attrFilters.value = nextAttrFilters

  emits('filter:apply', { ...params.value, ...otherParams, shipped: shippedKey, categoryIds: clsCheckIds.value, attrFilters: JSON.stringify(nextAttrFilters) })
  handleCloseClick()
}

const handleCloseClick = ()=>{
  emits('update:show', false)
}
</script>

<style lang="scss" scoped>
.filter-div::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.filter-wrapper{
  position: relative;
  height: calc(100vh - 106px);
  overflow: auto;
  :deep(.van-checkbox__label) {
    font-size: 24px;
    color: #333333;
  }
}
.bottom-opt{
  position: absolute;
  bottom: 2px;
  right: 0;
  left: 0;
  height: 100px;  
  line-height: 100px; 
  display: flex;
  padding: 0 10px;
  button:first-child {
    margin-right: 10px;
  }
  .-btn{
    flex: 0.5;
    text-align: center;
    font-size: 32px;
  }
  .reset{
    color: #DD3131;
  }
  .confirm{
    color: #fff;
    background-color: #DD3131;
  }
}
.title{
  height: 120px;
  line-height: 120px;
  padding: 0 30px;
  font-size: 36px;
  font-weight: 600;
  background-color: #DD3131;
  color: #fff;
  margin-bottom: 40px;
}
.filter-card{
  margin: 20px 0;
  padding: 0 30px;
  :deep(.van-collapse::after) {
    position: inherit;
  }
  :deep(.van-cell) {
    padding: 0;
    font-weight: 600;
  }
  :deep(.van-cell::after) {
    position: inherit;
  }
  :deep(.van-collapse-item__content) {
    padding: 0;
  }
  .card-title{
    margin: 20px 0;
    font-size: 28px;
    color: #333;
    font-weight: 600;
  }
  .filter-list{
    font-size: 28px;
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .van-checkbox-group {
      display: flex;
      flex-wrap: wrap;
    }
    .filter-item{
      height: 50px;
      margin-right: 30px;
    }
    .shipped-item{
      margin: 10px;
      padding: 10px;
      text-align: center;
      border: 1px solid #cacaca;
      border-radius: 6px;
      transition: all .1s;
    }
    .shipped-item-act{
      color:#DD3131;
      border-color: #DD3131;
    }
  }
  .price-box{
    @include center();
    .van-cell::after {
      content: '';
      position: initial;
    }
    :deep(input) {
      border: 1px solid #999999;
      border-radius: 4px;
      padding-left: 10px;
    }
    :deep(input::placeholder) {
      padding-left: 10px;
      font-weight: 400;
    }
    span {
      color: #999999;
      display: inline-block;
      margin: 0 8px;
    }
  }
}
.delivery-list{
  font-size: 28px;
}
</style>
